import React, { useState, useEffect, useRef } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import getIcon from "../../utils/getIcon";

const SelectDropdown = ({
  options,
  selectedOption,
  onSelectOption,
  className,
  defaultSelect,
  label,
  name,
  value,
  onChange,
  placeholder,
  icon,
  required = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [openUpwards, setOpenUpwards] = useState(false);
  const [localSelectedOption, setLocalSelectedOption] = useState();
 
  const dropdownRef = useRef(null);

  const IconComponent = icon ? getIcon(icon) : null;

  // Default option selection based on the `defaultSelect` prop
  useEffect(() => {
    if (defaultSelect) {
      const defaultOption = options?.find(
        (option) =>
          String(option.value).toLowerCase() ===
          String(defaultSelect).toLowerCase()
      );
      setLocalSelectedOption(defaultOption || null); // Set default if found
    }
  }, [defaultSelect, options]);

  useEffect(() => {
    const filtered = options.filter((option) =>
      (option?.label || "")
        .toLowerCase()
        .includes((searchTerm || "").toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [searchTerm, options]);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  // Handle option selection
  const handleOptionClick = (option) => {
    onSelectOption(option);
    setLocalSelectedOption(option);
    setIsOpen(false);
  };

  // Handle dynamic open/close based on dropdown position
  useEffect(() => {
    if (isOpen) {
      const dropdown = dropdownRef.current;
      const dropdownRect = dropdown.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (dropdownRect.bottom + 200 > windowHeight) {
        setOpenUpwards(true);
      } else {
        setOpenUpwards(false);
      }
    }
  }, [isOpen]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Search filtered options logic
  const filteredOptionsList = options?.filter((option) =>
    option.label?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
 <div
  className={`select-dropdown ${className ? className : ""} ${
    openUpwards ? "open-upwards" : ""
  }`}
  ref={dropdownRef}
>
  <div className="d-flex align-items-center">
    {label && (
      <label
        className="me-2 mb-0"
        style={{ whiteSpace: "nowrap" }}
      >
        {label}:{required && <span style={{ color: "red" }}> *</span>}
      </label>
    )}

    <div className="d-flex w-100">
      {IconComponent && (
        <span className="input-group-text border-end-0">{IconComponent}</span>
      )}
      <div className="select-box w-100" onClick={toggleDropdown}>
        <span className="selected-label">
          {value
            ? options.find((option) => String(option.value) === String(value))?.label
            : defaultSelect || "Select an option"}
        </span>
        <span className="arrow">
          {isOpen ? <FiChevronUp /> : <FiChevronDown />}
        </span>
      </div>
    </div>
  </div>

  {isOpen && (
    <div className="dropdown-list">
      <div className="search-input-outer">
        <input
          type="text"
          className="search-input"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <ul>
        {filteredOptionsList.length > 0 ? (
          filteredOptionsList.map((option) => (
            <li
              key={option.value}
              onClick={() => handleOptionClick(option)}
              className={`${String(option.value) === String(value)  ? "active" : ""}`}
            >
              {option.color && (
                <span
                  className="status-dot"
                  style={{ backgroundColor: option.color }}
                ></span>
              )}
              {option.icon && (
                <span className={`lh-1 fs-16 ${option.iconClassName}`}>
                  {getIcon(option.icon)}
                </span>
              )}
              {option.img && (
                <img src={option.img} className="avatar-image avatar-sm" />
              )}
              {option.label}
            </li>
          ))
        ) : (
          <li className="no-result">No results found</li>
        )}
      </ul>
    </div>
  )}
</div>

  );
};

export default SelectDropdown;
